/* ============================================================================
   Velven favourites
   Browser-local saved finishes, shared heart controls, and /pages/favourites.
   ========================================================================== */
(function () {
  "use strict";

  var STORAGE_KEY = "velven:favourites:v1";
  var FLIGHT_KEY = "velven:sample-flight:v1";
  var VIEW_KEY = "velven:favourites:view:v1";
  var BOX_SIZE = 6;
  var materials = window.VELVEN_MATERIALS || [];
  var byHandle = {};
  var routes = (window.theme && window.theme.routes) || {};
  var root = (routes.root_url || "/").replace(/\/$/, "");
  var cartAddUrl = routes.cart_add_url || root + "/cart/add.js";
  var cartUrl = routes.cart_url || root + "/cart";
  var reduceMotion = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  materials.forEach(function (m) {
    if (m && m.handle) byHandle[String(m.handle)] = m;
  });

  function readRaw() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
    } catch (e) {}
    return [];
  }

  function writeRaw(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    syncButtons();
    document.dispatchEvent(new CustomEvent("velven:favourites:change", {
      detail: { items: items.slice() }
    }));
  }

  function readViewState() {
    try {
      var raw = window.localStorage.getItem(VIEW_KEY);
      return raw ? JSON.parse(raw) || {} : {};
    } catch (e) {
      return {};
    }
  }

  function writeViewState(state) {
    try {
      window.localStorage.setItem(VIEW_KEY, JSON.stringify(state || {}));
    } catch (e) {}
  }

  function parsePrice(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function materialPrice(m) {
    if (!m) return 0;
    if (m.price) return parsePrice(m.price);
    if (!m.sizes) return 0;
    var order = ["r60", "r90", "r120", "a4"];
    for (var i = 0; i < order.length; i++) {
      var s = m.sizes[order[i]];
      if (s && s.id && s.price) return parsePrice(s.price);
    }
    return 0;
  }

  function fromDataset(button) {
    return {
      handle: button.getAttribute("data-fav-handle") || "",
      name: button.getAttribute("data-fav-name") || "",
      url: button.getAttribute("data-fav-url") || "",
      image: button.getAttribute("data-fav-image") || "",
      finish: button.getAttribute("data-fav-finish") || "",
      tone: button.getAttribute("data-fav-tone") || "",
      ground: button.getAttribute("data-fav-ground") || "",
      price: parsePrice(button.getAttribute("data-fav-price")),
      savedAt: new Date().toISOString(),
      finalist: false
    };
  }

  function freshen(item) {
    item = item || {};
    var handle = String(item.handle || "");
    var m = byHandle[handle] || {};
    return {
      handle: handle,
      name: m.name || item.name || handle,
      url: m.url || item.url || (handle ? "/products/" + handle : "/collections/all-finishes"),
      image: m.image || item.image || "",
      finish: m.finish || item.finish || "Velven finish",
      tone: (m.tone || item.tone || "").toLowerCase(),
      ground: m.ground || m.plane || item.ground || item.plane || "#ECE5D6",
      price: materialPrice(m) || parsePrice(item.price),
      blurb: m.blurb || item.blurb || "",
      tip: m.tip || item.tip || "",
      savedAt: item.savedAt || new Date().toISOString(),
      finalist: item.finalist === true
    };
  }

  function list() {
    return readRaw().map(freshen).filter(function (item) { return !!item.handle; });
  }

  function dedupe(items) {
    var seen = {};
    var out = [];
    items.forEach(function (item) {
      var fresh = freshen(item);
      if (!fresh.handle || seen[fresh.handle]) return;
      seen[fresh.handle] = true;
      out.push(fresh);
    });
    return out;
  }

  function saveItems(items) {
    writeRaw(dedupe(items));
  }

  function findIndex(items, handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return i;
    }
    return -1;
  }

  function toggle(input) {
    var item = freshen(input);
    if (!item.handle) return null;
    var items = list();
    var idx = findIndex(items, item.handle);
    if (idx >= 0) {
      items.splice(idx, 1);
    } else {
      item.savedAt = new Date().toISOString();
      item.finalist = false;
      items.unshift(item);
    }
    saveItems(items);
    return item;
  }

  function remove(handle) {
    handle = String(handle || "");
    saveItems(list().filter(function (item) { return item.handle !== handle; }));
  }

  function clear() {
    saveItems([]);
  }

  function setFinalist(handle, finalist) {
    handle = String(handle || "");
    var changed = null;
    var items = list().map(function (item) {
      if (item.handle === handle) {
        item.finalist = finalist === true;
        changed = item;
      }
      return item;
    });
    saveItems(items);
    return changed;
  }

  function moveBefore(handle, targetHandle, after) {
    handle = String(handle || "");
    targetHandle = String(targetHandle || "");
    if (!handle || !targetHandle || handle === targetHandle) return;
    var items = list();
    var from = findIndex(items, handle);
    var to = findIndex(items, targetHandle);
    if (from < 0 || to < 0) return;
    var moving = items.splice(from, 1)[0];
    if (from < to) to -= 1;
    if (after) to += 1;
    items.splice(Math.max(0, Math.min(items.length, to)), 0, moving);
    saveItems(items);
  }

  function toneKey(item) {
    var tone = String((item && item.tone) || "").toLowerCase();
    if (tone.indexOf("light") !== -1) return "light";
    if (tone.indexOf("mid") !== -1 || tone.indexOf("medium") !== -1) return "mid";
    if (tone.indexOf("dark") !== -1) return "dark";
    return "other";
  }

  function shadeLabel(key) {
    if (key === "light") return "Light";
    if (key === "mid") return "Medium";
    if (key === "dark") return "Dark";
    return "Other saved";
  }

  function toneWeight(item, desc) {
    var key = typeof item === "string" ? item : toneKey(item);
    if (key === "other") return 3;
    if (desc) {
      if (key === "dark") return 0;
      if (key === "mid") return 1;
      return 2;
    }
    if (key === "light") return 0;
    if (key === "mid") return 1;
    return 2;
  }

  function nameSort(a, b) {
    return String(a.name || "").localeCompare(String(b.name || ""));
  }

  function sortItems(items, mode) {
    var out = items.slice();
    if (mode === "custom") return out;
    if (mode === "newest") {
      return out.sort(function (a, b) {
        return new Date(b.savedAt || 0).getTime() - new Date(a.savedAt || 0).getTime() || nameSort(a, b);
      });
    }
    return out.sort(function (a, b) {
      var desc = mode === "toneDesc";
      var aw = toneWeight(a, desc);
      var bw = toneWeight(b, desc);
      return aw - bw || nameSort(a, b);
    });
  }

  function addUnique(out, seen, item, limit) {
    if (!item || !item.handle || seen[item.handle] || out.length >= limit) return;
    seen[item.handle] = true;
    out.push(item);
  }

  function buildSampleFlight(limit) {
    limit = limit || BOX_SIZE;
    var saved = list();
    var out = [];
    var seen = {};
    saved.filter(function (item) { return item.finalist; }).forEach(function (item) {
      addUnique(out, seen, item, limit);
    });
    saved.forEach(function (item) { addUnique(out, seen, item, limit); });
    return out.slice(0, limit);
  }

  function storeSampleFlight(handles) {
    try {
      window.localStorage.setItem(FLIGHT_KEY, JSON.stringify({
        handles: handles.slice(0, BOX_SIZE),
        createdAt: new Date().toISOString()
      }));
    } catch (e) {}
  }

  function syncButtons() {
    var items = list();
    var saved = {};
    items.forEach(function (item) { saved[item.handle] = true; });

    Array.prototype.forEach.call(document.querySelectorAll("[data-fav-button]"), function (button) {
      var handle = button.getAttribute("data-fav-handle");
      var isSaved = !!saved[handle];
      var name = button.getAttribute("data-fav-name") || "this finish";
      button.classList.toggle("is-saved", isSaved);
      if (!isSaved) button.classList.remove("is-just-saved");
      button.setAttribute("aria-pressed", isSaved ? "true" : "false");
      button.setAttribute("aria-label", (isSaved ? "Remove " : "Save ") + name + (isSaved ? " from favourites" : " to favourites"));
      var label = button.querySelector("[data-fav-label]");
      if (label) {
        label.textContent = isSaved
          ? (button.getAttribute("data-fav-remove-label") || "Remove from favourites")
          : (button.getAttribute("data-fav-save-label") || "Save to favourites");
      }
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-favourites-count]"), function (el) {
      el.textContent = String(items.length);
      el.hidden = items.length === 0 && el.hasAttribute("data-hide-zero");
    });
  }

  function money(cents) {
    cents = parsePrice(cents);
    return cents ? "$" + (cents / 100).toFixed(2) : "";
  }

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function materialFor(item) {
    return byHandle[item && item.handle] || {};
  }

  function sizeData(item, key) {
    var m = materialFor(item);
    return m && m.sizes ? m.sizes[key] : null;
  }

  function feelText(item) {
    var finish = String(item.finish || "").toLowerCase();
    if (finish.indexOf("satin") !== -1) {
      return "Soft satin sheen with a smooth sealed face. Easy to wipe, with a gentle glow rather than a gloss flash.";
    }
    if (finish.indexOf("matte") !== -1) {
      return "Low sheen and calmer under light, with a smooth dry touch vinyl face.";
    }
    if (finish.indexOf("gloss") !== -1) {
      return "A brighter reflective face. Best checked as a sample in the room light it will live in.";
    }
    return "Smooth peel and stick vinyl with a printed finish face. Order a sample when touch and room light matter.";
  }

  function renderThumb(item) {
    var img = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.name + " " + item.finish) + '" loading="lazy" decoding="async">'
      : "";
    return '<span class="vmcm-favstudio__cardimg" style="--ground:' + esc(item.ground) + '">' + img + '</span>';
  }

  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var INFO_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="7.6" r="1.3" fill="currentColor"/><rect x="10.9" y="10.2" width="2.2" height="7.2" rx="1.1" fill="currentColor"/></svg>';

  function renderSwatch(item, pickIndex) {
    var picked = pickIndex >= 0;
    var img = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.name + " " + item.finish) + '" loading="lazy" decoding="async">'
      : "";
    return '' +
      '<div class="vmcm-sample__item" data-fav-card="' + esc(item.handle) + '"' + (toneKey(item) !== "other" ? ' data-tone="' + esc(toneKey(item)) + '"' : '') + '>' +
        '<a class="vmcm-sample__swatch vmcm-favstudio__card" href="' + esc(item.url || ("/products/" + item.handle)) + '" aria-label="See ' + esc(item.name) + '" style="--ground:' + esc(item.ground) + '">' +
          '<span class="vmcm-sample__chip">' + img + '</span>' +
          '<span class="vmcm-sample__label"><span class="vmcm-sample__name">' + esc(item.name) + '</span><span class="vmcm-sample__fin">' + esc(item.finish || "Velven finish") + '</span></span>' +
        '</a>' +
        '<button type="button" class="vmcm-fav vmcm-fav--sample is-saved" data-fav-remove-studio="' + esc(item.handle) + '" aria-label="Remove ' + esc(item.name) + ' from favourites">' +
          '<span class="vmcm-fav__icon vmcm-fav__icon--off" aria-hidden="true">' + HEART_SVG + '</span>' +
          '<span class="vmcm-fav__icon vmcm-fav__icon--on" aria-hidden="true">' + HEART_SVG + '</span>' +
        '</button>' +
        '<button type="button" class="vmcm-peek__btn" data-fav-details="' + esc(item.handle) + '" aria-haspopup="dialog" aria-label="More about ' + esc(item.name) + '">' + INFO_SVG + '</button>' +
      '</div>';
  }

  function chipsHtml(item) {
    if (!window.VMCM_KIN || !materials.length) return "";
    var close = window.VMCM_KIN.rank(item, materials).slice(0, 3);
    if (!close.length) return "";
    var chips = close.map(function (m) {
      var c = freshen({ handle: m.handle });
      return '<button type="button" class="vmcm-favstudio__suggestchip" data-peek-open="' + esc(c.handle) + '" style="--ground:' + esc(c.ground) + '">' +
        (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<span>' + esc(c.name) + '</span>' +
      '</button>';
    }).join("");
    return '<div class="vmcm-favstudio__peekclose">' +
      '<p class="vmcm-favstudio__suggestlabel">Close to this finish</p>' +
      '<div class="vmcm-favstudio__suggestrow">' + chips + '</div>' +
    '</div>';
  }

  function detailHtml(item) {
    var a4 = sizeData(item, "a4");
    var r60 = sizeData(item, "r60");
    var r90 = sizeData(item, "r90");
    var r120 = sizeData(item, "r120");
    return '' +
      '<div class="vmcm-favstudio__detail">' +
        renderThumb(item) +
        '<div class="vmcm-favstudio__detailbody">' +
          '<p class="vmcm-favstudio__meta">' + esc(item.finish || "Velven finish") + '</p>' +
          '<h2>' + esc(item.name) + '</h2>' +
          (item.blurb ? '<p>' + esc(item.blurb) + '</p>' : '') +
          '<p>' + esc(feelText(item)) + '</p>' +
          '<dl>' +
            '<div><dt>Finish</dt><dd>' + esc(item.finish || "Velven finish") + '</dd></div>' +
            '<div><dt>Shade</dt><dd>' + esc(shadeLabel(toneKey(item))) + '</dd></div>' +
            '<div><dt>Touch</dt><dd>Smooth peel and stick film</dd></div>' +
            '<div><dt>A4 sample</dt><dd>' + esc(a4 && a4.id ? money(a4.price) : "Unavailable") + '</dd></div>' +
            '<div><dt>60cm roll</dt><dd>' + esc(r60 && r60.id ? money(r60.price) + " / m" : "Unavailable") + '</dd></div>' +
            '<div><dt>90cm roll</dt><dd>' + esc(r90 && r90.id ? money(r90.price) + " / m" : "Unavailable") + '</dd></div>' +
            '<div><dt>120cm roll</dt><dd>' + esc(r120 && r120.id ? money(r120.price) + " / m" : "Unavailable") + '</dd></div>' +
          '</dl>' +
          (item.tip ? '<p class="vmcm-favstudio__tip">' + esc(item.tip) + '</p>' : '') +
          chipsHtml(item) +
        '</div>' +
      '</div>';
  }

  function cartAdd(items) {
    var request = function () {
      return fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return res.json();
      });
    };
    var mutation = window.VelvenCartEvents
      ? window.VelvenCartEvents.add({ target: document, context: "dialog", items: items }, request)
      : request();
    return mutation.then(function (json) {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return json;
    });
  }

  function initStudio(studio) {
    var countEl = studio.querySelector("[data-fav-studio-count]");
    var readyEl = studio.querySelector("[data-fav-ready]");
    var emptyEl = studio.querySelector("[data-fav-empty]");
    var savedEl = studio.querySelector("[data-fav-saved-grid]");
    var browseTitleEl = studio.querySelector("[data-fav-browse-title]");
    var catalogueEl = studio.querySelector("[data-fav-catalogue]");
    var sampleCountEls = Array.prototype.slice.call(studio.querySelectorAll("[data-sample-count]"));
    var sampleConfirmBtns = Array.prototype.slice.call(studio.querySelectorAll("[data-sample-confirm]"));
    var sampleErrorEls = Array.prototype.slice.call(studio.querySelectorAll("[data-sample-error]"));
    var clearBtn = studio.querySelector("[data-fav-clear]");
    var trayEl = studio.querySelector("[data-flight-trays]");
    var hintEl = studio.querySelector("[data-sample-hint]");
    var suggestEl = studio.querySelector("[data-fav-suggest]");
    var suggestRowEl = studio.querySelector("[data-fav-suggest-row]");
    var filterBtns = Array.prototype.slice.call(studio.querySelectorAll("[data-fav-filter]"));
    var filterEmptyEl = studio.querySelector("[data-fav-filter-empty]");
    var detailModal = studio.querySelector("[data-fav-detail-modal]");
    var detailBody = studio.querySelector("[data-fav-detail-body]");
    var sampleVariant = parseInt(studio.getAttribute("data-sample-box-variant"), 10) || 0;
    var samplePicks = [];
    var knownFavouriteHandles = list().map(function (item) { return item.handle; });
    var sampleOrigLabels = sampleConfirmBtns.map(function (btn) {
      var label = btn.querySelector("[data-sample-confirmlabel]");
      return label ? label.textContent : "Add my box";
    });
    var viewState = readViewState();
    var activeFilter = viewState.filter || "all";
    var suppressNextChange = false;

    function itemByHandle(handle) {
      var items = list();
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle === handle) return items[i];
      }
      return null;
    }

    function setMessage(text) {
      sampleErrorEls.forEach(function (el) {
        el.textContent = text || "";
      });
    }

    function validFilter(value) {
      return value === "light" || value === "mid" || value === "dark" ? value : "all";
    }

    activeFilter = validFilter(activeFilter);

    function saveViewState() {
      writeViewState({ filter: activeFilter });
    }

    function updateControls() {
      filterBtns.forEach(function (btn) {
        var on = btn.getAttribute("data-fav-filter") === activeFilter;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    function boardItems(items) {
      var sorted = sortItems(items, "newest");
      if (activeFilter === "all") return sorted;
      return sorted.filter(function (item) { return toneKey(item) === activeFilter; });
    }

    // A pick is valid as long as it is a real finish (has a material record),
    // so box picks made from the empty-state catalogue survive re-renders and
    // are not wiped just because they are not favourites. Removing a favourite
    // still drops its pick explicitly in the remove handler.
    function filterPicks() {
      samplePicks = samplePicks.filter(function (handle) { return !!byHandle[handle]; });
    }

    function setConfirmLabels(text) {
      sampleConfirmBtns.forEach(function (btn, idx) {
        var label = btn.querySelector("[data-sample-confirmlabel]");
        if (label) label.textContent = text || sampleOrigLabels[idx] || "Add my box";
      });
    }

    function renderTrayRow(rowPicks, priceLabel) {
      var slots = [];
      for (var i = 0; i < BOX_SIZE; i++) {
        var handle = rowPicks[i];
        var item = handle ? itemByHandle(handle) : null;
        if (item) {
          slots.push('<li class="vmcm-favstudio__slot is-filled" style="--ground:' + esc(item.ground) + '">' +
            (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.name) + '" loading="lazy" decoding="async">' : '') +
            '<button type="button" class="vmcm-favstudio__slotremove" data-sample-swatch data-handle="' + esc(item.handle) + '" data-finish="' + esc(item.name) + '" aria-label="Take ' + esc(item.name) + ' out of the box">&times;</button>' +
          '</li>');
        } else {
          slots.push('<li class="vmcm-favstudio__slot"></li>');
        }
      }
      return '<div class="vmcm-favstudio__trayrow">' +
        '<ol class="vmcm-favstudio__slots">' + slots.join('') + '</ol>' +
        '<p class="vmcm-favstudio__trayrowprice">' + esc(priceLabel) + '</p>' +
      '</div>';
    }

    function renderTray() {
      if (!trayEl) return;
      var rows = [];
      var i = 0;
      while (i + BOX_SIZE <= samplePicks.length) {
        var group = samplePicks.slice(i, i + BOX_SIZE);
        rows.push(renderTrayRow(group, VelvenSamplePricing.money(group.reduce(function (sum, h) { return sum + a4Price(h); }, 0))));
        i += BOX_SIZE;
      }
      var remainder = samplePicks.slice(i);
      var remainderPrice = remainder.length
        ? VelvenSamplePricing.money(remainder.reduce(function (sum, h) { return sum + a4Price(h); }, 0))
        : "";
      rows.push(renderTrayRow(remainder, remainderPrice));
      trayEl.innerHTML = rows.join("");
    }

    function a4Price(handle) {
      var m = byHandle[handle];
      // byHandle carries Shopify's raw cents value (see snippets/vmcm-materials-data.liquid);
      // convert to dollars since VelvenSamplePricing's money math expects dollars.
      return (m && m.sizes && m.sizes.a4 && m.sizes.a4.price) ? parseFloat(m.sizes.a4.price) / 100 : 0;
    }

    function renderSuggestions() {
      if (!suggestEl || !suggestRowEl) return;
      var savedItems = list();
      var saved = {};
      savedItems.forEach(function (item) { saved[item.handle] = true; });
      /* Only offer new finishes when the saved shortlist cannot fill the box
         on its own; otherwise the shopper picks from what they saved. */
      var wantSuggestions = ((samplePicks.length % BOX_SIZE) !== 0 || samplePicks.length === 0) && savedItems.length < BOX_SIZE;
      var pool = [];
      if (wantSuggestions) {
        pool = materials.filter(function (m) {
          return m && m.handle && !saved[m.handle];
        });
        // Smart order: closest to anything they already saved (vmcm-kin.js),
        // falling back to catalogue order when the scorer is absent.
        if (window.VMCM_KIN && savedItems.length) {
          pool = window.VMCM_KIN.rankToSet(savedItems, pool);
        }
        pool = pool.slice(0, 6);
      }
      if (!pool.length) {
        suggestEl.hidden = true;
        suggestRowEl.innerHTML = "";
        return;
      }
      suggestEl.hidden = false;
      suggestRowEl.innerHTML = pool.map(function (m) {
        var item = freshen({ handle: m.handle });
        return '<button type="button" class="vmcm-favstudio__suggestchip" data-fav-suggest-add="' + esc(item.handle) + '" style="--ground:' + esc(item.ground) + '">' +
          (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<span>' + esc(item.name) + '</span>' +
        '</button>';
      }).join("");
    }

    function updateSampleUI() {
      studio.classList.toggle("has-picks", samplePicks.length > 0);
      sampleCountEls.forEach(function (el) {
        el.textContent = String(samplePicks.length);
      });
      sampleConfirmBtns.forEach(function (btn) {
        btn.disabled = samplePicks.length === 0 || !sampleVariant;
      });
      setConfirmLabels(samplePicks.length ? VelvenSamplePricing.confirmLabel(samplePicks.length) : "Choose a finish to start");
      if (hintEl) {
        hintEl.textContent = VelvenSamplePricing.nudgeLine(samplePicks.length);
      }
      renderTray();
      renderSuggestions();
      // Reflect box picks on any server-rendered swatches (the empty-state
      // catalogue). The favourites grid re-renders its own picked state; this
      // keeps the static catalogue swatches (tick + aria) in step too.
      Array.prototype.forEach.call(studio.querySelectorAll("[data-sample-swatch]"), function (btn) {
        var picked = samplePicks.indexOf(btn.getAttribute("data-handle")) >= 0;
        btn.classList.toggle("is-picked", picked);
        btn.setAttribute("aria-pressed", picked ? "true" : "false");
      });
    }

    function snapshotCards() {
      var rects = {};
      if (!savedEl) return rects;
      Array.prototype.forEach.call(savedEl.querySelectorAll("[data-fav-card]"), function (card) {
        rects[card.getAttribute("data-fav-card")] = card.getBoundingClientRect();
      });
      return rects;
    }

    function animateCards(prevRects) {
      if (!savedEl || !prevRects || reduceMotion) return;
      Array.prototype.forEach.call(savedEl.querySelectorAll("[data-fav-card]"), function (card) {
        var prev = prevRects[card.getAttribute("data-fav-card")];
        if (!prev || !card.animate) return;
        var next = card.getBoundingClientRect();
        var dx = prev.left - next.left;
        var dy = prev.top - next.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        card.animate([
          { transform: "translate(" + dx + "px, " + dy + "px)" },
          { transform: "translate(0, 0)" }
        ], {
          duration: 240,
          easing: "cubic-bezier(.2,.75,.2,1)"
        });
      });
    }

    function animateNewCards(handles) {
      if (!savedEl || reduceMotion || !handles || !handles.length) return;
      handles.forEach(function (handle) {
        var card = savedEl.querySelector('[data-fav-card="' + handle.replace(/"/g, '\\"') + '"]');
        if (!card || !card.animate) return;
        card.animate([
          { opacity: 0, transform: "translateY(14px) scale(.985)" },
          { opacity: 1, transform: "translateY(0) scale(1)" }
        ], { duration: 280, easing: "cubic-bezier(.2,.8,.2,1)" });
      });
    }

    function render(prevRects, enteredHandles) {
      var items = list();
      var shown = boardItems(items);
      filterPicks();
      if (countEl) countEl.textContent = String(items.length);
      if (clearBtn) clearBtn.disabled = items.length === 0;
      updateControls();

      var hasFavs = items.length > 0;
      // Favourites are pulled to the top; the section only shows when you have some.
      if (readyEl) readyEl.hidden = !hasFavs;
      if (emptyEl) emptyEl.hidden = hasFavs;
      if (hasFavs && savedEl) {
        savedEl.innerHTML = shown.map(function (item) {
          return renderSwatch(item, samplePicks.indexOf(item.handle));
        }).join("");
        if (filterEmptyEl) filterEmptyEl.hidden = shown.length !== 0;
        animateCards(prevRects);
        animateNewCards(enteredHandles);
      }

      if (browseTitleEl) {
        browseTitleEl.textContent = hasFavs ? "Everything else" : "You have not saved a favourite yet.";
      }
      // The whole catalogue lives below. Hide any tile that is already a
      // favourite (it is shown up top) so nothing appears twice; un-favouriting
      // brings it back into the catalogue on the next render.
      if (catalogueEl) {
        var saved = {};
        items.forEach(function (item) { saved[item.handle] = true; });
        Array.prototype.forEach.call(catalogueEl.querySelectorAll(".vmcm-sample__item"), function (el) {
          el.hidden = !!saved[el.getAttribute("data-handle")];
        });
      }

      updateSampleUI();
    }

    function openModal(modal) {
      if (!modal) return;
      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");
    }

    function closeModal(modal) {
      if (!modal) return;
      if (typeof modal.close === "function") modal.close();
      else modal.removeAttribute("open");
    }

    function openDetail(handle) {
      if (!detailBody) return;
      // Saved favourites resolve from the list; catalogue tiles that are not
      // saved yet still peek fine by materialising straight from the blob.
      var item = itemByHandle(handle) || (byHandle[handle] ? freshen({ handle: handle }) : null);
      if (!item) return;
      detailBody.innerHTML = detailHtml(item);
      openModal(detailModal);
    }

    function handleSampleAdd() {
      if (!samplePicks.length || !sampleVariant) return;
      var resolvedPicks = [];
      for (var i = 0; i < samplePicks.length; i++) {
        var handle = samplePicks[i];
        var m = byHandle[handle];
        if (!m || !m.sizes || !m.sizes.a4 || !m.sizes.a4.id) {
          setMessage("One of your picks has no sample available. Remove it to continue.");
          return;
        }
        resolvedPicks.push({ name: m.name || handle, a4Id: m.sizes.a4.id, handle: handle });
      }
      var items = VelvenSamplePricing.buildCartItems(resolvedPicks, sampleVariant);
      sampleConfirmBtns.forEach(function (btn) { btn.disabled = true; });
      setConfirmLabels("Adding...");
      setMessage("");
      storeSampleFlight(samplePicks);
      cartAdd(items).then(function () {
        window.location.href = cartUrl;
      }).catch(function () {
        setMessage("Something slipped. Try once more.");
        updateSampleUI();
      });
    }

    studio.addEventListener("click", function (e) {
      var closeHit = e.target.closest("[data-fav-modal-close]");
      if (closeHit) {
        e.preventDefault();
        closeModal(closeHit.closest("dialog"));
        return;
      }

      var clearHit = e.target.closest("[data-fav-clear]");
      if (clearHit) {
        e.preventDefault();
        samplePicks = [];
        clear();
        render();
        return;
      }

      var filterHit = e.target.closest("[data-fav-filter]");
      if (filterHit) {
        e.preventDefault();
        var filterRects = snapshotCards();
        activeFilter = validFilter(filterHit.getAttribute("data-fav-filter"));
        saveViewState();
        render(filterRects);
        return;
      }

      var sheetHit = e.target.closest("[data-fav-open-sheet]");
      if (sheetHit) {
        var sheetModal = sheetHit.closest("dialog");
        if (sheetModal) closeModal(sheetModal);
        return;
      }

      var sampleAddHit = e.target.closest("[data-sample-confirm]");
      if (sampleAddHit) {
        e.preventDefault();
        handleSampleAdd();
        return;
      }

      var suggestHit = e.target.closest("[data-fav-suggest-add]");
      if (suggestHit) {
        e.preventDefault();
        var suggestHandle = suggestHit.getAttribute("data-fav-suggest-add");
        var alreadySaved = list().some(function (item) { return item.handle === suggestHandle; });
        if (!alreadySaved) {
          suppressNextChange = true;
          toggle(freshen({ handle: suggestHandle }));
        }
        if (samplePicks.indexOf(suggestHandle) < 0) {
          samplePicks.push(suggestHandle);
        }
        setMessage("");
        render();
        return;
      }

      var sampleHit = e.target.closest("[data-sample-swatch]");
      if (sampleHit) {
        e.preventDefault();
        var sampleHandle = sampleHit.getAttribute("data-handle");
        var pos = samplePicks.indexOf(sampleHandle);
        if (pos >= 0) {
          samplePicks.splice(pos, 1);
          setMessage("");
        } else {
          samplePicks.push(sampleHandle);
          setMessage("");
        }
        // Picking does not change the favourites list, only which cards are in
        // the box. Re-render just the box UI (tray, counts, swatch picked state)
        // instead of rebuilding the whole grid innerHTML, which recreated every
        // <img> and made the cards flicker on each pick.
        updateSampleUI();
        return;
      }

      var detailsHit = e.target.closest("[data-fav-details]");
      if (detailsHit) {
        e.preventDefault();
        // Catalogue tiles carry data-handle on the item div; without this the
        // same click bubbles on to vmcm-feed.js and opens the selection sheet.
        e.stopPropagation();
        openDetail(detailsHit.getAttribute("data-fav-details"));
        return;
      }

      var peekOpenHit = e.target.closest("[data-peek-open]");
      if (peekOpenHit) {
        e.preventDefault();
        e.stopPropagation();
        openDetail(peekOpenHit.getAttribute("data-peek-open"));
        return;
      }


      var removeHit = e.target.closest("[data-fav-remove-studio]");
      if (removeHit) {
        e.preventDefault();
        var removeHandle = removeHit.getAttribute("data-fav-remove-studio");
        var removeRects = snapshotCards();
        samplePicks = samplePicks.filter(function (handle) { return handle !== removeHandle; });
        var removeModal = removeHit.closest("dialog");
        if (removeModal) closeModal(removeModal);
        suppressNextChange = true;
        remove(removeHandle);
        render(removeRects);
      }
    });

    if (detailModal) {
      detailModal.addEventListener("click", function (e) {
        if (e.target === detailModal) closeModal(detailModal);
      });
    }

    document.addEventListener("velven:favourites:change", function () {
      if (suppressNextChange) {
        suppressNextChange = false;
        knownFavouriteHandles = list().map(function (item) { return item.handle; });
        return;
      }
      var currentHandles = list().map(function (item) { return item.handle; });
      var enteredHandles = currentHandles.filter(function (handle) { return knownFavouriteHandles.indexOf(handle) < 0; });
      knownFavouriteHandles = currentHandles;
      render(null, enteredHandles);
    });
    render();
  }

  document.addEventListener("click", function (e) {
    var button = e.target.closest("[data-fav-button]");
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var wasSaved = button.classList.contains("is-saved");
    toggle(fromDataset(button));
    if (!wasSaved && button.classList.contains("is-saved") && !reduceMotion) {
      button.classList.add("is-just-saved");
      /* Failsafe: hidden tabs never fire animationend (no frames are drawn),
         so clear the one-beat class on a timer as well. */
      setTimeout(function () { button.classList.remove("is-just-saved"); }, 1400);
    }
  }, true);

  /* One beat per save: drop the pulse class when its animation finishes.
     Name guard matters, the studio board FLIP animations bubble here too. */
  document.addEventListener("animationend", function (e) {
    if (e.animationName !== "vmcm-fav-heart-pop") return;
    var button = e.target && e.target.closest ? e.target.closest("[data-fav-button]") : null;
    if (button) button.classList.remove("is-just-saved");
  });

  /* Quick view on surfaces WITHOUT a favourites studio (the Sample Box
     picker): vmcm-feed.js owns pick state there, so this binds on the panel
     itself ([data-peek-scope], deeper than .vmcm-feed) and routes picks
     through the real swatch buttons. The studio page never reaches here. */
  function initPeek(scope) {
    var modal = scope.querySelector("[data-fav-detail-modal]");
    var body = scope.querySelector("[data-fav-detail-body]");
    if (!modal || !body) return;

    function close() {
      if (typeof modal.close === "function") modal.close();
      else modal.removeAttribute("open");
    }

    function open(handle) {
      if (!byHandle[handle]) return;
      body.innerHTML = detailHtml(freshen({ handle: handle }));
      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");
    }

    scope.addEventListener("click", function (e) {
      var detailsHit = e.target.closest("[data-fav-details]");
      if (detailsHit) {
        e.preventDefault();
        e.stopPropagation();
        open(detailsHit.getAttribute("data-fav-details"));
        return;
      }
      var openHit = e.target.closest("[data-peek-open]");
      if (openHit) {
        e.preventDefault();
        e.stopPropagation();
        open(openHit.getAttribute("data-peek-open"));
        return;
      }
      var closeHit = e.target.closest("[data-fav-modal-close]");
      if (closeHit) {
        e.preventDefault();
        close();
      }
    });
    modal.addEventListener("click", function (e) {
      if (e.target === modal) close();
    });
  }

  window.VELVEN_FAVOURITES = {
    list: list,
    toggle: toggle,
    remove: remove,
    clear: clear,
    setFinalist: setFinalist,
    moveBefore: moveBefore,
    buildSampleFlight: buildSampleFlight,
    storageKey: STORAGE_KEY,
    sampleFlightKey: FLIGHT_KEY
  };

  syncButtons();
  Array.prototype.forEach.call(document.querySelectorAll("[data-favourites-studio]"), initStudio);
  if (!document.querySelector("[data-favourites-studio]")) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-peek-scope]"), initPeek);
  }
})();
